exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".v-sheet--offset{top:-24px;position:relative}", "", {"version":3,"sources":["/vercel/path0/src/pages/Home.vue"],"names":[],"mappings":"AACA,iBACE,UAAW,AACX,iBAAmB,CACpB","file":"Home.vue","sourcesContent":["\n.v-sheet--offset {\n  top: -24px;\n  position: relative;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6e7e8aba","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/Home.vue
// module id = 451
// module chunks = 15